import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import BathroomService from '../../api/services/BathroomService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
const BathroomManagement = () => {

    const [BathroomManagement, setBathroomManagement] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = BathroomManagement.slice(firstIndex, lastIndex);
    const npage = Math.ceil(BathroomManagement.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        getBathroomManagement();
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getBathroomManagement = async () => {
        try {
            let BathroomManagement = await BathroomService.index().json();
            setBathroomManagement(BathroomManagement.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const deleteBathroomManagement = async (id) => {


        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await BathroomService.destroy(id).json();
                if (responseData.status === true) {
                    getBathroomManagement();
                }
                swal("Your Hygiene has been deleted successfully!", {
                    icon: "success",
                });

            }
        }).catch(() => {
            swal("Your BathroomManagement is safe!");
        });
    }
    return (
        <>
            <MainPagetitle mainTitle="Bathroom" pageTitle={'Bathroom'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Bathroom Management</h4>
                                        <div>
                                            <Link to={`/admin/add_bathroom_management/`} className="btn btn-primary btn-sm ms-1">+ Add Bathroom</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Title</th>
                                                    <th>Image</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{index + 1}</span></td>
                                                        <td>
                                                            <div className="products">
                                                                <div>
                                                                    <h6>{item.title}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td><img className="img-drop-area" height={item.icon ? 50 : 0} width={item.icon ? 50 : 0} src={imageUrl + "Bathroom/" + item.icon} alt='brand' /></td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit_bathroom_management/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => deleteBathroomManagement(item.id)}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {BathroomManagement.length < lastIndex ? BathroomManagement.length : lastIndex}
                                                {" "}of {BathroomManagement.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default BathroomManagement;